"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ArticleStyledComponentContainer;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _framerMotion = require("framer-motion");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Packages

// Styles
const StyledComponentContainer = (0, _styledComponents.default)(_framerMotion.motion.div).withConfig({
  displayName: "article-progress-bar__StyledComponentContainer",
  componentId: "sc-1kawtdy-0"
})(["background:", ";height:4px;left:0;position:absolute;transform-origin:0%;width:100%;"], props => props.categoryBadgeHoverColor);

// Main Component
function ArticleStyledComponentContainer({
  articleProgressBarRoot,
  articleProgressBarContainer,
  categoryBadgeHoverColor
}) {
  const progressBar = (0, _react.useRef)(null);
  const {
    scrollYProgress
  } = (0, _framerMotion.useScroll)({
    layoutEffect: false,
    target: articleProgressBarRoot,
    container: articleProgressBarContainer,
    offset: ["0 0", "1 0.7"] // first value is target, second value is container (in each pair)
  });

  const scaleX = (0, _framerMotion.useSpring)(scrollYProgress, {
    stiffness: 100,
    damping: 50,
    restDelta: 1
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledComponentContainer, {
    ref: progressBar,
    style: {
      scaleX
    },
    className: "progress-bar",
    categoryBadgeHoverColor: categoryBadgeHoverColor
  }));
}
ArticleStyledComponentContainer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArticleStyledComponentContainer"
};